import * as React from "react";
import type { SVGProps } from "react";
const SvgDowngrade = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g fill="currentColor" clipPath="url(#downgrade_svg__a)">
      <path d="M19 4H5c-.55 0-1-.45-1-1s.45-1 1-1h14c.55 0 1 .45 1 1s-.45 1-1 1M12 22c-.55 0-1-.45-1-1V7c0-.55.45-1 1-1s1 .45 1 1v14c0 .55-.45 1-1 1" />
      <path d="M12 22c-.26 0-.51-.1-.71-.29l-5-5A.996.996 0 1 1 7.7 15.3l4.29 4.29 4.29-4.29a.996.996 0 1 1 1.41 1.41l-5 5c-.2.2-.45.29-.71.29z" />
    </g>
    <defs>
      <clipPath id="downgrade_svg__a">
        <path fill="#fff" d="M4 2h16v20H4z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgDowngrade;
